import { useState } from "react";
import { Controller } from "react-hook-form";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export const TextInput = (props) => {
  const {
    id,
    label,
    control,
    style,
    disabled = false,
    rules,
    defaultValue = "",
    value = "",
    maxLength = -1,
    onKeyDownHandler,
    type = "text",
    showPasswordToggle = false,
  } = props;

  const [showPassword, setShowPassword] = useState(false);

  const keyDownHandler = (e) => {
    if (!onKeyDownHandler) return;
    onKeyDownHandler(e);
  };

  const inputType =
    type === "password" && showPasswordToggle
      ? showPassword
        ? "text"
        : "password"
      : type;

  const EyeIcon =
    type === "password" && showPasswordToggle ? (
      <InputAdornment position="end">
        <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ) : null;

  if (!control) {
    return (
      <TextField
        size="small"
        label={label}
        className="mt-8 mb-2 mx-8"
        fullWidth
        variant="outlined"
        disabled={disabled}
        inputProps={{ maxLength }}
        style={style}
        value={value}
        type={inputType}
        InputProps={EyeIcon ? { endAdornment: EyeIcon } : {}}
      />
    );
  }

  return (
    <Controller
      name={id}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          helperText={error ? error.message : null}
          error={!!error}
          size="small"
          id={id}
          label={label}
          className="mt-8 mb-2 mx-8"
          fullWidth
          variant="outlined"
          disabled={disabled}
          inputProps={{ maxLength }}
          onKeyDown={keyDownHandler}
          style={style}
          type={inputType}
          InputProps={EyeIcon ? { endAdornment: EyeIcon } : {}}
          {...field}
        />
      )}
    />
  );
};
